import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4.875 7a4.625 4.625 0 1 1 9.25 0 4.625 4.625 0 0 1-9.25 0ZM9.5 3.625a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.92 3.056a.625.625 0 0 1 .815-.345 4.626 4.626 0 0 1 0 8.578.625.625 0 0 1-.47-1.16 3.376 3.376 0 0 0 0-6.259.625.625 0 0 1-.344-.814ZM7.977 14.375h3.046c.912 0 1.629 0 2.208.04.59.04 1.082.123 1.539.312a4.625 4.625 0 0 1 2.503 2.503c.189.456.272.95.313 1.539.039.579.039 1.296.039 2.208V21a.625.625 0 1 1-1.25 0c0-.94 0-1.614-.037-2.146-.036-.526-.105-.867-.22-1.146a3.375 3.375 0 0 0-1.826-1.826c-.28-.115-.62-.184-1.146-.22-.532-.037-1.206-.037-2.146-.037H8c-.94 0-1.614 0-2.146.037-.526.035-.867.104-1.146.22-.827.342-1.484 1-1.826 1.826-.116.28-.185.62-.22 1.146-.037.532-.037 1.206-.037 2.146a.625.625 0 1 1-1.25 0v-.023c0-.912 0-1.629.04-2.208.04-.59.123-1.082.312-1.539a4.625 4.625 0 0 1 2.503-2.503c.456-.189.95-.272 1.539-.313.579-.039 1.296-.039 2.208-.039Zm10.418.595a.625.625 0 0 1 .76-.45 4.627 4.627 0 0 1 3.47 4.48v2a.625.625 0 1 1-1.25 0v-2a3.377 3.377 0 0 0-2.53-3.269.625.625 0 0 1-.45-.76Z"
    />
  </svg>
`;
